module.exports = __webpack_public_path__ + "static/4_2_recommendation_SK-dc4d139d3a27bc36e4cb428893f29500.svg";